import { Chart } from "chart.js";

const snapshots = new WeakMap();

// Only chart chrome changes: dataset colors, values and agricultural thresholds
// retain their meaning. Snapshot explicit options so toggling back is reversible.
export const chartThemePlugin = {
  id: "smartfarmTheme",
  beforeUpdate(chart) {
    const dark = document.documentElement.dataset.theme === "dark";
    let saved = snapshots.get(chart);
    if (!dark && !saved) return;
    if (!saved) { saved = new Map(); snapshots.set(chart, saved); }
    const set = (object, property, value) => {
      let properties = saved.get(object);
      if (!properties) { properties = new Map(); saved.set(object, properties); }
      if (!properties.has(property)) properties.set(property, object[property]);
      if (dark) object[property] = value;
    };
    const options = chart.config.options;
    if (dark) {
      options.plugins = options.plugins || {};
      const legend = options.plugins.legend;
      if (legend !== false) {
        options.plugins.legend = legend || {};
        const labels = options.plugins.legend.labels || {};
        options.plugins.legend.labels = labels;
        set(labels, "color", "#c3d0da");
      }
      ["title", "subtitle"].forEach((key) => {
        if (options.plugins[key]) set(options.plugins[key], "color", "#e6edf3");
      });
      Object.values(options.scales || {}).forEach((scale) => {
        scale.ticks = scale.ticks || {};
        scale.grid = scale.grid || {};
        scale.border = scale.border || {};
        set(scale.ticks, "color", "#9fb0bd");
        set(scale.grid, "color", "rgba(159,176,189,.16)");
        set(scale.border, "color", "#314657");
        if (scale.title) set(scale.title, "color", "#c3d0da");
        if (scale.pointLabels) set(scale.pointLabels, "color", "#c3d0da");
        if (scale.angleLines) set(scale.angleLines, "color", "#314657");
      });
    } else {
      saved.forEach((properties, object) => {
        properties.forEach((value, property) => {
          if (value === undefined) delete object[property];
          else object[property] = value;
        });
      });
      snapshots.delete(chart);
    }
  },
  afterDestroy(chart) { snapshots.delete(chart); },
};

Chart.register(chartThemePlugin);

export function refreshChartThemes() {
  Object.values(Chart.instances).forEach((chart) => chart.update("none"));
}
